export default __webpack_public_path__ + "static/media/search.7e6201e0.svg";